export function accountFromDto(accountDto, companyUserDto = {}) {

    const accountType = accountDto.accountType;
    const isAD = accountType === 'AD';
    const isSimpleUsername = accountType === 'SIMPLE_USERNAME';
    const isInternalEmail = accountType === 'INTERNAL_EMAIL';
    const isExternalEmail = accountType === 'EXTERNAL_EMAIL';
    const isPhoneNumber = accountType === 'PHONENUMBER';
    const isSharedEmail = accountType === 'SHARED_EMAIL';
    const isActive = accountDto.status === 'ACTIVE';
    const isBlocked = companyUserDto.blocked !== 'NONE';
    const isEndUser = companyUserDto.roleType === 'END_USER';
    const isAdmin = accountDto.isAdmin || accountDto.username === companyUserDto.userIdentifyingName;

    return {
        ...accountDto,
        isDeletable: !isAD && (isEndUser || !isAdmin),
        isDisownable: isActive && !isBlocked && (
            isAD || isSharedEmail || isSimpleUsername || isInternalEmail && (isEndUser || !isAdmin)
        ),
        isVerifyable: !isExternalEmail && !isPhoneNumber,
        isCopyable: isInternalEmail || isSimpleUsername || isSharedEmail || isAD,
        isAdmin
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/account.dto.js